import i18n from '@/i18n/index';
import { TYPE_DEVIS, TYPE_COMMANDE } from '@/configuration/devisConf';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import formatDate from '@/services/general/formatDate';

function getDcfLibelle(dcfType) {
  switch (dcfType) {
    case TYPE_DEVIS:
      return i18n.t('validationDevis.messageIndispo.devis');
    case TYPE_COMMANDE:
      return i18n.t('validationDevis.messageIndispo.commande');
    default:
      return '';
  }
}

function getCommercialMessage(userId, users) {
  if (!userId) return '';
  const user = users.find((u) => u.id === +userId);
  if (!user) return '';
  return i18n.t('validationDevis.messageIndispo.parCommercial', {
    commercial: nomPrenomGetter(user),
  });
}

export default function getMessageIndisoFace(message, users) {
  if (!message) return '';
  if (message.indexOf('SELECTION_FACE_RESEAU_FACE_DANS_VENTE_RESEAU_TEMPOS') === 0) {
    const elements = message.split('|')[0].split('@');
    return i18n.t('validationDevis.messageIndispo.faceDansVenteTempos', {
      reseau: elements[4],
      dcfType: getDcfLibelle(elements[1]),
      dcfCode: elements[2],
      commercial: getCommercialMessage(elements[5], users),
      annonceur: elements[3],
    });
  }
  if (message.indexOf('SELECTION_FACE_RESEAU_FACE_VENTE_LC') === 0) {
    const elements = message.split('|')[0].split('@');
    return i18n.t('validationDevis.messageIndispo.faceVenteLC', {
      dateDebut: formatDate(elements[5]),
      dateFin: formatDate(elements[6]),
      dcfType: getDcfLibelle(elements[1]),
      dcfCode: elements[2],
      commercial: getCommercialMessage(elements[3], users),
      annonceur: elements[7],
    });
  }
  if (message.indexOf('SELECTION_FACE_RESEAU_FACE_AFFECTE_LOGISTIQUEMENT') === 0) {
    const elements = message.split('|')[0].split('@');
    return i18n.t('validationDevis.messageIndispo.faceAffecteLogistiquement', {
      reseauDcfLibelle: [elements[1], elements[2], elements[3]].filter(Boolean).join(' - '),
    });
  }
  if (message.indexOf('SELECTION_FACE_RESEAU_FACE_ARCHIVE') === 0) {
    return i18n.t('validationDevis.messageIndispo.faceArchive');
  }
  if (message.indexOf('SELECTION_FACE_RESEAU_FACE_INDISPONIBLE') === 0) {
    return i18n.t('validationDevis.messageIndispo.faceIndisponible');
  }
  if (message.indexOf('SELECTION_FACE_RESEAU_FACE_SELECTIONNE_AUCUNE_VENTE') === 0) {
    return i18n.t('validationDevis.messageIndispo.faceSelectionAucuneVente');
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/services/reseauxTempo/getMessageIndispoFace.js